import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BillingBillAccountDataAccessModule } from '@amfam/billing/billaccount/data-access';

import { CommunicationPreferencesEffects } from './+state/communication-preferences.effects';
import * as fromCommunicationPreferences from './+state/communication-preferences.reducer';
import { reducers } from './+state/communication-preferences.selectors';

@NgModule({
  imports: [
    CommonModule,
    BillingBillAccountDataAccessModule,
    StoreModule.forFeature(
      fromCommunicationPreferences.communicationPreferencesFeatureKey,
      reducers
    ),
    EffectsModule.forFeature([CommunicationPreferencesEffects])
  ]
})
export class ProfileCommunicationPreferencesDataAccessModule {}
